export default __webpack_public_path__ + "2ec8b60695d5fc98f3168347e980a2bb.svg";